import { AntButton } from 'components/ant/AntButton/AntButton';
import { UpdatePnmModal } from 'components/Modals/UpdatePnmModal';
import { UpdatePsmModal } from 'components/Modals/UpdatePsmModal';
import { Status, StatusType } from 'components/UI/Status';
import { dateFormat } from 'components/utils/formatters';
import { IProvider } from 'interfaces/graphql';
import React, { FC, useState } from 'react';

import s from './MainInfo.module.less';

export const PROVIDER_STATE_MAPPING = {
  found_by_us: { label: 'Found By Us', type: StatusType.Blue, outline: false, oldColor: '#1979C3' },
  enrolled_via_website: { label: 'Enrolled Via Website', type: StatusType.Blue, outline: false, oldColor: '#2690DD' },
  probation: { label: 'Probation', type: StatusType.Green, outline: true, oldColor: '#73BE7F' },
  test_part: { label: 'Test part', type: StatusType.Orange, outline: false, oldColor: '#D46B08' },
  trusted: { label: 'Trusted', type: StatusType.Green, outline: false, oldColor: '#219653' },
  blacklist: { label: 'Blacklist', type: StatusType.Red, outline: false, oldColor: '#9E3C3C' },
  deleted: { label: 'Deleted', type: StatusType.Red, outline: false, oldColor: '#9E3C3C' },
};

interface Props {
  provider: IProvider;
}

export const MainInfo: FC<Props> = ({ provider }) => {
  const [updatePnmModalVisible, setUpdatePnmModalVisible] = useState<boolean>(false);
  const [updatePsmModalVisible, setUpdatePsmModalVisible] = useState<boolean>(false);

  return (
    <>
      <div className={s.titleWrapper}>
        <div className={s.providerId}>PR-{provider.id}</div>
        {PROVIDER_STATE_MAPPING[provider.state] ? (
          <Status
            type={PROVIDER_STATE_MAPPING[provider.state].type}
            outline={PROVIDER_STATE_MAPPING[provider.state].outline}
          >
            {PROVIDER_STATE_MAPPING[provider.state].label}
          </Status>
        ) : null}
      </div>
      <div className={s.mainInfoWrapper}>
        <div>
          Registered:&nbsp;
          {dateFormat(provider.createdAt)}
        </div>
        <div>
          Last PA visit:&nbsp;
          {dateFormat(provider.lastVisitAt)}
        </div>
        <div>
          PNM:&nbsp;
          <AntButton type="link" onClick={() => setUpdatePnmModalVisible(true)} className="p-none" size="small">
            {provider.partnerNetworkManager?.name || 'No PNM'}
          </AntButton>
        </div>

        <div>
          PSM:&nbsp;
          <AntButton type="link" onClick={() => setUpdatePsmModalVisible(true)} className="p-none" size="small">
            {provider.partnerSuccessManager?.name || 'No PSM'}
          </AntButton>
        </div>
      </div>

      <div className={s.holidaysTagsWrapper}>
        {provider.publicHoliday ? (
          <Status type={StatusType.Green} outline>
            Public holidays
          </Status>
        ) : null}
        {provider.productionHoliday ? (
          <Status type={StatusType.Red} outline>
            Production holidays
          </Status>
        ) : null}
      </div>

      <UpdatePnmModal
        provider={provider}
        visible={updatePnmModalVisible}
        onCancel={() => setUpdatePnmModalVisible(false)}
      />

      <UpdatePsmModal
        provider={provider}
        visible={updatePsmModalVisible}
        onCancel={() => setUpdatePsmModalVisible(false)}
      />
    </>
  );
};
